import { render, staticRenderFns } from "./HolidayCreate.vue?vue&type=template&id=0876b4cc"
import script from "../../../controllers/custom/holiday/holiday-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/holiday/holiday-create.js?vue&type=script&lang=js&external"
import style0 from "./HolidayCreate.vue?vue&type=style&index=0&id=0876b4cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports